import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import { allFilterPages, generateOrderDashboardParams } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

import { getOrderDashboardFilterOptionSearch } from '@services/orderDashboard';

const OrderTitle = ({ filterPageName, showFilter }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const [search, setSearch] = useState('');
	const debounceSearch = useDebouncedCallback((text) => setSearch(text), 500);
	const orderDashboardFilterFields = useSelector((store) => store.filterFieldStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.MY_ORDER]: dependentFilterList?.orderList
	};
	const onFetchData = async () => {
		let responseData = filterData[filterPageName] || [];
		setAllData(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		debounceSearch(e.target.value);
	};

	useEffect(() => {
		if (showFilter) {
			(async () => {
				let orderQuery = generateOrderDashboardParams(orderDashboardFilterFields);
				const data = await getOrderDashboardFilterOptionSearch(
					`?filterType=ORDER&search=${search}${orderQuery}`
				);
				setData(data);
			})();
		}
	}, [search, showFilter]);

	return (
		<>
			<FilterName type="ORDER_TITLE" />
			<Checkbox data={data} type="ORDER_TITLE" handleSearch={handleSearch} />
		</>
	);
};

export default OrderTitle;
